@if (numberOfPages > 1) {
  <div class="container display-flex justify-content-center f-align-items-center">
    <div class="pagination">
      @if (currentPage > 1) {
        <a class="pagination__item" 
          [routerLink]="pageUrl()"
          [queryParams]="queryParams(currentPage - 1)">
            <span class="icon-arrow-left"></span>
        </a>
      }
      @if (showFirstPageWithDots()) {
        <a class="pagination__item"
          [routerLink]="pageUrl()" 
          [queryParams]="queryParams(1)">
            1
        </a>
        <span class="mx">...</span>
      }
      @for (page of showedPages; track page) {
        <a class="pagination__item"
          [ngClass]="{'is-active': currentPage === page}"
          [ngStyle]="{'width': getPaginationItemWidth(page)}"
          [routerLink]="pageUrl()" 
          [queryParams]="queryParams(page)">
            {{ page }}
        </a>
      }
      @if (showLastPageWithDots()) {
        <span class="mx">...</span>
        <a class="pagination__item"
          [ngStyle]="{'width': getPaginationItemWidth(numberOfPages)}"
          [routerLink]="pageUrl()" 
          [queryParams]="queryParams(numberOfPages)">
            {{ numberOfPages }}
        </a>
      }
      @if (currentPage < numberOfPages) {
        <a class="pagination__item" 
          [routerLink]="pageUrl()"
          [queryParams]="queryParams(currentPage + 1)">
            <span class="icon-arrow-right"></span>
        </a>
      }
    </div>
  </div>
}
